import "core-js/modules/es7.array.includes.js";
import jwtDecode from 'jwt-decode';
var decodedToken = () => jwtDecode(localStorage.getItem('MDM_ACCESS_TOKEN'));
var isValidToken = () => {
  if (!hasToken()) return false;
  var {
    exp
  } = decodedToken();
  return !!(localStorage.getItem('MDM_ACCESS_TOKEN') && new Date().getTime() < exp * 1000);
};
var hasApiAudience = _ref => {
  var {
    apiName
  } = _ref;
  var {
    aud
  } = decodedToken();
  return Array.isArray(aud) && aud.includes(apiName) || aud === apiName;
};
var hasToken = () => !!localStorage.getItem('MDM_ACCESS_TOKEN');
export { isValidToken, hasApiAudience, decodedToken, hasToken };